import type { ReactNode } from 'react'
import React from 'react'
import { ShowIf } from '../ShowIf'
import { useToggle } from 'react-use'
import { HorizontalStack } from '../HorizontalStack'
import { Stack } from 'react-bootstrap'
import { HideIf } from '../HideIf'
import { Switch } from '../Switch'
import { CollapseControl } from '../CollapseControl'
export type SectionNameProps = {
  title?: ReactNode
  description?: any
  children?: React.ReactNode
  showDivision?: boolean
  isCollapsible?: boolean
  initialCollapse?: boolean
  sideContent?: ReactNode
}

export const SectionName = ({
  title,
  description,
  children,
  showDivision = true,
  isCollapsible = false,
  initialCollapse = true,
  sideContent,
}: SectionNameProps) => {
  const [collapse, setCollapse] = useToggle(initialCollapse)

  return (
    <Stack>
      <HorizontalStack className="justify-content-between">
        <div>
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault()
              setCollapse()
            }}
          >
            <b className=" m-0 p-0">{title}</b>
          </a>
          <div>{description}</div>
        </div>
        <div>
          <ShowIf condition={!!sideContent}>{sideContent}</ShowIf>
          <ShowIf condition={!sideContent && isCollapsible}>
            <CollapseControl show={collapse} setShow={setCollapse} />
          </ShowIf>
        </div>
      </HorizontalStack>

      <ShowIf condition={!!children}>
        <Switch expression={isCollapsible}>
          {{
            // The rule lives INSIDE the same `HideIf` as the children — while collapsed, `hr` was
            // previously rendered unconditionally above this `Switch`, painting a header rule over
            // an otherwise-empty collapsed body.
            true: (
              <HideIf condition={collapse}>
                {showDivision && <hr />}
                {children}
              </HideIf>
            ),
            false: (
              <>
                {showDivision && <hr />}
                {children}
              </>
            ),
          }}
        </Switch>
      </ShowIf>
    </Stack>
  )
}
